import { Button } from '@gerdau/hefesto/Button';
import React, { useEffect } from 'react';

import { Icon } from '@gerdau/hefesto/Icon';
import { Title } from '@gerdau/hefesto/Title';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ERoutes } from '../../../../../routes';
import { ApplicationState } from '../../../../../store';
import { sendTagging } from '../../../../../store/ducks/tagging/actions';
import { formatTaggingString } from '../../../../../utils/formatStrings';
import { CheckCircleIcon, Container, TitleContainer } from './styles';
import { cleanShoppingCart } from '../../../../../store/ducks/long-steel-shopping-cart/actions';

interface ISuccessProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  orderInPDF: any;
}

const Success: React.FC<ISuccessProps> = ({ orderInPDF }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const shoppingCartState = useSelector(
    (state: ApplicationState) => state.longSteelShoppingCart
  );
  const taggingInfoPreviousScreen = useSelector(
    (state: ApplicationState) => state.longSteelShoppingCart
  );

  const orders = shoppingCartState.createdOrders || [];

  const goToOrders = () => {
    dispatch(
      sendTagging({
        screenName: `LG:Comprar:AcosLongos:${taggingInfoPreviousScreen.screenName}:EnviarParaAnalise`,
        page: window.location.pathname,
        order: shoppingCartState.createdOrders?.join(','),
        orderCliente: formatTaggingString(shoppingCartState.customerOrder),
        itemName: 'button:ir_para_pedidos',
        itemDescription: `comprar_acosLongos_${taggingInfoPreviousScreen.itemDescription}_enviarParaAnalise_irParaPedidos`,
        event: 'click'
      })
    );
    history.push(ERoutes.ORDERS);
  };

  useEffect(() => {
    dispatch(
      sendTagging({
        screenName: `LG:Comprar:AcosLongos:${taggingInfoPreviousScreen.screenName}:EnviarParaAnalise`,
        page: window.location.pathname,
        order: shoppingCartState.createdOrders?.join(','),
        orderCliente: formatTaggingString(shoppingCartState.customerOrder),
        event: 'page_view'
      })
    );

    return () => {
      dispatch(cleanShoppingCart());
    };
  }, [
    dispatch,
    shoppingCartState.createdOrders,
    shoppingCartState.customerOrder
  ]);

  const onPdfDownloadClick = () => {
    dispatch(
      sendTagging({
        screenName: `LG:Comprar:AcosLongos:${taggingInfoPreviousScreen.screenName}:EnviarParaAnalise`,
        page: window.location.pathname,
        order: shoppingCartState.createdOrders?.join(','),
        orderCliente: formatTaggingString(shoppingCartState.customerOrder),
        itemName: 'button:baixarPdfDoPedido',
        itemDescription: `comprar_acosLongos_${taggingInfoPreviousScreen.itemDescription}_enviarParaAnalise_baixarPdfDoPedido`,
        event: 'click'
      })
    );
    const pdfFileName = 'PEDIDO_' + orders.join('_');
    orderInPDF.save(pdfFileName);
  };

  return (
    <Container>
      <CheckCircleIcon>
        <Icon option="CheckCircle" variant="success"></Icon>
      </CheckCircleIcon>

      <TitleContainer>
        <Title level={2}>Pedido Finalizado!</Title>
      </TitleContainer>

      <span className="confirm-message">
        O pedido nº{' '}
        <strong>{orders.length > 1 ? orders.join(', ') : orders[0]}</strong> foi
        enviado para análise com sucesso.
      </span>

      <span className="detail-message">
        Em alguns instantes você poderá consultar seu pedido no menu{' '}
        <strong>Pedidos</strong>. <br />
        Importante: o preço irá aparecer após o seu vendedor fazer o ajuste
        comercial <br />
        no nosso sistema, e será atualizado automaticamente.
      </span>

      <div className="actions">
        {orderInPDF && (
          <Button
            name="button-pdf"
            variant="primary"
            onClick={onPdfDownloadClick}
          >
            Baixar PDF do pedido
          </Button>
        )}

        <Button name="button-pedidos" variant="secondary" onClick={goToOrders}>
          Ir para Pedidos
        </Button>
      </div>
    </Container>
  );
};

export default Success;
